import type {
  SvpCategory,
  SvpAsset,
  DataType,
  PresetElement,
} from '../../types';

/**
 * Returns the first result that is not already selected, based on `id`.
 * Used to implement "Enter adds the top result" behaviour in the preset
 * search inputs.
 */
export const getFirstUnselectedResult = <T extends { id: string | number }>(
  results: T[],
  selectedIds: Array<string | number>
): T | undefined => results.find((result) => !selectedIds.includes(result.id));

export const isCategory = (item: PresetElement): item is SvpCategory =>
  Object.prototype.hasOwnProperty.call(item, 'isSeries');
export const isAsset = (item: PresetElement): item is SvpAsset =>
  Object.prototype.hasOwnProperty.call(item, 'streamType');

export const getItemDataType = (item: PresetElement, dataType: DataType) => {
  switch (dataType) {
    case 'profiles':
      return 'profile';
    case 'stories':
      return 'story';
    case 'assets':
      return 'asset';
    case 'categories':
      return 'category';
    case 'mixed': {
      if (isCategory(item)) {
        return 'category';
      }
      if (isAsset(item)) {
        return 'asset';
      }
    }
  }

  return undefined;
};
